class BlockFlipCards {
	constructor() {
		const blocks = document.querySelectorAll(".block-flip-cards");

		blocks.forEach(block => {
			const delay = block.dataset.aosDelay;
			const card1 = block.querySelector(".flip-card-1");
			const card2 = block.querySelector(".flip-card-2");
			const card3 = block.querySelector(".flip-card-3");
			const card4 = block.querySelector(".flip-card-4");

			ScrollTrigger.create({
				trigger: block,
				start: 'top 80%',
				once: true,
				onEnter: function () {
					if (delay) {
						setTimeout(function () {
							block.classList.add('appeared');
						}, parseInt(delay));
					} else {
						block.classList.add('appeared');
					}
				}
			});
		});
	}
}